module.exports = __webpack_public_path__ + "static/media/shopping-online.458b0a1e.jpg";